<app-header></app-header>
<app-sidevar></app-sidevar>
<div class="content-wrapper">
  <app-breadcrums></app-breadcrums>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
